/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Must_Be_Under_10mbInputs */

const en_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File must be under 10MB`)
};

const es_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El archivo debe ser menor a 10MB`)
};

const fr_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le fichier doit faire moins de 10 Mo`)
};

const de_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Datei muss kleiner als 10MB sein`)
};

const ja_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルは10MB未満である必要があります`)
};

const zh_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件必须小于 10MB`)
};

const ar_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجب أن يكون حجم الملف أقل من 10 ميغابايت`)
};

const id_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File harus di bawah 10MB`)
};

const it_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il file deve essere inferiore a 10 MB`)
};

const ru_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл должен быть меньше 10МБ`)
};

const pt_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O arquivo deve ter menos de 10MB`)
};

const ko_file_must_be_under_10mb = /** @type {(inputs: File_Must_Be_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일 크기는 10MB 미만이어야 합니다`)
};

/**
* | output |
* | --- |
* | "File must be under 10MB" |
*
* @param {File_Must_Be_Under_10mbInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const file_must_be_under_10mb = /** @type {((inputs?: File_Must_Be_Under_10mbInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Must_Be_Under_10mbInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_file_must_be_under_10mb(inputs)
	if (locale === "es") return es_file_must_be_under_10mb(inputs)
	if (locale === "fr") return fr_file_must_be_under_10mb(inputs)
	if (locale === "de") return de_file_must_be_under_10mb(inputs)
	if (locale === "ja") return ja_file_must_be_under_10mb(inputs)
	if (locale === "zh") return zh_file_must_be_under_10mb(inputs)
	if (locale === "ar") return ar_file_must_be_under_10mb(inputs)
	if (locale === "id") return id_file_must_be_under_10mb(inputs)
	if (locale === "it") return it_file_must_be_under_10mb(inputs)
	if (locale === "ru") return ru_file_must_be_under_10mb(inputs)
	if (locale === "pt") return pt_file_must_be_under_10mb(inputs)
	return ko_file_must_be_under_10mb(inputs)
});